<template>
  <div class="live-work-stats" :title="helpText">
    {{ workStatsText }}
  </div>
</template>

<script>
import { invoke } from "@/utils/identificationSignal";
import { mapGetters } from "vuex";
import { getters } from "@/store";

export default {
  data() {
    return {
      workerCount: null,
      identificationCount: null,
      lastUpdate: null,
      workStatsInterval: null
    };
  },
  computed: {
    ...mapGetters([getters.isWorking]),
    workStatsText() {
      return [
        "W: ",
        this.workerCount ?? "?",
        ", I: ",
        this.identificationCount ?? "?"
      ].join("");
    },
    helpText() {
      const updateTime = this.lastUpdate
        ? [
            this.lastUpdate.getHours(),
            this.lastUpdate.getMinutes(),
            this.lastUpdate.getSeconds()
          ].join(":")
        : "-";
      return [
        "W - active workers",
        "I - identifications waiting for worker",
        `Last update: ${updateTime}`
      ].join("\n");
    }
  },
  methods: {
    async updateLiveWorkStats() {
      await Promise.all([this.getUserCount(), this.getIdentificationCount()]);
      this.lastUpdate = new Date();
    },
    async getUserCount() {
      try {
        this.workerCount = await invoke("GetConnectedUsersCount");
      } catch (error) {
        this.workerCount = null;
      }
    },
    async getIdentificationCount() {
      try {
        this.identificationCount = await invoke(
          "GetPendingIdentificationCount"
        );
      } catch (error) {
        this.identificationCount = null;
      }
    },
    startPolling() {
      this.updateLiveWorkStats();
      this.workStatsInterval = setInterval(this.updateLiveWorkStats, 10000);
    },
    stopPolling() {
      if (this.workStatsInterval) {
        clearInterval(this.workStatsInterval);
        this.workStatsInterval = null;
      }
    }
  },
  watch: {
    isWorking: {
      immediate: true,
      handler(val) {
        if (val) {
          this.startPolling();
        } else {
          this.stopPolling();
        }
      }
    }
  },
  beforeDestroy() {
    this.stopPolling();
  }
};
</script>

<style scoped lang="scss">
.live-work-stats {
  padding: 0.5rem 0;
  text-align: center;
  cursor: help;
}
</style>
